import { isFeatureRequestAdmin, isFeatureRequestOwner } from "./featureRequestPermissions";

export const FEATURE_REQUEST_STATUSES = [
  "New",
  "Under Review",
  "Planned",
  "In Progress",
  "Completed",
  "Declined",
];

export const FEATURE_REQUEST_RESOLUTION_STATUSES = [
  "Completed",
  "Declined",
];

export const requiresFeatureRequestResolutionComment = (status) =>
  FEATURE_REQUEST_RESOLUTION_STATUSES.includes(
    String(status || "").trim(),
  );

const statusOrder = FEATURE_REQUEST_STATUSES.reduce(
  (order, status, index) => ({ ...order, [status]: index }),
  {},
);

const normalizeStatus = (status) => String(status || "New").trim() || "New";

const getTimestamp = (value) => {
  if (!value) return 0;
  if (typeof value.toMillis === "function") return value.toMillis();
  if (typeof value.toDate === "function") return value.toDate().getTime();
  if (typeof value.seconds === "number") return value.seconds * 1000;

  const timestamp = new Date(value).getTime();
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

const compareFeatureRequestsByDate = (left, right) => {
  const createdDifference =
    getTimestamp(right && right.createdAt) -
    getTimestamp(left && left.createdAt);
  if (createdDifference !== 0) return createdDifference;

  return String((left && left.id) || "").localeCompare(
    String((right && right.id) || ""),
  );
};

export const compareFeatureRequestsByStatus = (left, right) => {
  const leftStatus = normalizeStatus(left && left.status);
  const rightStatus = normalizeStatus(right && right.status);
  const leftOrder = Object.prototype.hasOwnProperty.call(statusOrder, leftStatus)
    ? statusOrder[leftStatus]
    : FEATURE_REQUEST_STATUSES.length;
  const rightOrder = Object.prototype.hasOwnProperty.call(statusOrder, rightStatus)
    ? statusOrder[rightStatus]
    : FEATURE_REQUEST_STATUSES.length;

  if (leftOrder !== rightOrder) return leftOrder - rightOrder;
  if (leftStatus !== rightStatus) return leftStatus.localeCompare(rightStatus);

  return compareFeatureRequestsByDate(left, right);
};

export const sortFeatureRequestsForUser = (requests, user) => {
  const prioritizeOwnRequests = !isFeatureRequestAdmin(user);

  return [...(Array.isArray(requests) ? requests : [])].sort((left, right) => {
    if (prioritizeOwnRequests) {
      const ownershipDifference =
        Number(isFeatureRequestOwner(user, right)) -
        Number(isFeatureRequestOwner(user, left));
      if (ownershipDifference !== 0) return ownershipDifference;
    }

    return compareFeatureRequestsByStatus(left, right);
  });
};
